/**
 * Tiny typed wrapper around localStorage that won't blow up in SSR or
 * private-browsing contexts. Used for auth tokens; we accept the lower
 * security bar of localStorage for Phase 0 and will swap to httpOnly
 * cookies if/when the deployment requires it.
 */
export const storage = {
  get(key: string): string | null {
    try {
      return window.localStorage.getItem(key);
    } catch {
      return null;
    }
  },
  set(key: string, value: string): void {
    try {
      window.localStorage.setItem(key, value);
    } catch {
      // ignore quota / disabled storage
    }
  },
  remove(key: string): void {
    try {
      window.localStorage.removeItem(key);
    } catch {
      // ignore
    }
  },
};
